import { isValidObjectId } from "../../../../utils/objectIdUtils";
import { getVariableMappingTypeOptions } from "../utils";
import FieldSelectorFromPopup from "../../FieldSelectorFromPopup";
import Input from "../../../FormComponents/Input";

const SingleMapping = ({ data, onChange, tableId, tableType, formFields }) => {
  const handleFieldChange = (field, newValue) => {
    const currentItem = data || {};

    if (field === "type") {
      const updatedItem = {
        ...currentItem,
        type: newValue,
        value: ""
      };
      onChange(updatedItem);
    } else {
      const updatedItem = {
        ...currentItem,
        type: currentItem.type || "mapped",
        [field]: newValue
      };
      onChange(updatedItem);
    }
  };

  const hasValue = (data) => {
    return data.value && data.value.toString().trim() !== "";
  };

  const getDataTypeInput = (type, value) => {
    switch (type) {
      case "mapped":
        return (
          <FieldSelectorFromPopup
            tableId={tableId}
            tableType={tableType}
            onSelect={(field) => handleFieldChange("value", field.id)}
            fieldId={value}
          />
        );
      case "form":
        return (
          <select
            className="builder_input"
            value={value || ""}
            onChange={(e) => handleFieldChange("value", e.target.value)}
          >
            <option value="">Select form field</option>
            {formFields.map((field) => (
              <option key={field.id} value={field.id}>
                {field.label}
              </option>
            ))}
          </select>
        );

      case "hardcoded":
        return (
          <Input
            value={value}
            onChange={(e) => handleFieldChange("value", e.target.value)}
            inputBoxStyle={{ maxWidth: "none" }}
          />
        );
      default:
        break;
    }
  };

  const { key, value, type = "mapped" } = data || {};

  return (
    <tr className={hasValue(data) ? "highlighted-row" : ""}>
      <td className="activity_table_key">
        <div className="d_flex g_8" style={{ color: !isValidObjectId(data.key || "") ? "#3a1890" : "black" }}>
          {key}
        </div>
      </td>
      <td className="activity_table_select">
        <select className="builder_input" value={type} onChange={(e) => handleFieldChange("type", e.target.value)}>
          {getVariableMappingTypeOptions("http")}
        </select>
      </td>
      <td className="activity_table_value">
        <div className="selected_value_items">
          <div className="activity_selected_value_item w_100">{getDataTypeInput(type, value)}</div>
        </div>
      </td>
    </tr>
  );
};

export default SingleMapping;
